import z from 'zod';
import { link } from '../../custom-events/link.schema';

export default z.object(link);
